module.exports = __webpack_public_path__ + "static/media/girl-waving.02b559c3.png";